import React from 'react';
export function Highlight({
  children
}: {
  children: React.ReactNode;
}) {
  return <span className="rounded-md bg-gold px-2 text-brand [box-decoration-break:clone] [-webkit-box-decoration-break:clone]" data-id="element-28" data-mp="1y85nw8xnzud">
      {children}
    </span>;
}